const strings = {
  title: 'Interações Referência',
}

export default strings
